/* eslint semi:0 */
import { mountAll } from '../../jsCore/utils/component'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import userToolbarComponent from '../../jsCore/organizedByType/components/userToolbarComponent'
import { registerHamburger } from '../hamburger/hamburger'
import googleSearchComponent from '../../jsCore/organizedByType/components/googleSearchComponent'
import { injectSearch } from '../search/searchInjector'
import initializeEditionSelection from '../edition_dropdown/editionDropdown'
import { addOnOrientationChangeEvent } from '../../jsCore/utils/window'
import { toggleBemClass, bem, node } from '../../jsCore/utils/dom'
import { SELECTORS } from '../../jsCore/config/preRenderedSelectorsConfig'
import {
  getPlatform,
  getIsDesktop,
  getIsMobileOrTablet,
  getIsIos,
  getIsMobile,
  getIsTablet,
  getIsTabletInPortrait,
  viewport,
} from '../../jsCore/utils/ua'
import { ads, getPageDomain } from '../../jsCore/application/pageDataObject'
import { adStore } from '../../jsCore/organizedByType/stores/adStore'
import { TYPES } from '../../jsCore/organizedByType/actions/adActions'

const px = num => `${num}px`

let pageWrap = null
let headerNode = null
let navigationNode = null
const DESKTOP_HEADER_HEIGHT = 106
function getHeaderNode() {
  headerNode = headerNode || node(SELECTORS.SITE_HEADER)
  return headerNode
}
function getNavigationNode() {
  navigationNode = navigationNode || node(SELECTORS.NAVIGATION)
  return navigationNode
}
let headerAdNode = null

function initDialogProvider(predicate) {
  if (predicate) {
    require('../../jsCore/providers/dialogProvider')
  }
  return predicate
}

export function mobileHeaderOrientationHandler(vm) {
  addOnOrientationChangeEvent(
    () => {
      repositionMobileHeader(vm)
    },
    () => {
      repositionMobileHeader(vm)
    }
  )
}

export function repositionMobileHeader(vm) {
  // eslint-disable-line complexity
  if (getIsTablet() && viewport.orientation === 'landscape') {
    removeHeaderMargins()
    return this
  }
  if (getIsMobileOrTablet() || getIsIos()) {
    addHeaderMargins(vm)
  }
  return this
}

function removeHeaderMargins() {
  headerAdNode = headerAdNode || node(SELECTORS.HEADER_AD_UNIT)
  getHeaderNode().style.marginTop = 0
  getNavigationNode().style.marginTop = 0
  headerAdNode.style.marginTop = px(DESKTOP_HEADER_HEIGHT)
  pageWrap = pageWrap || node(SELECTORS.PAGE_WRAP)
  pageWrap.style.marginTop = 0
}

function addHeaderMargins(vm) {
  const { mobileHeaderTop } = vm
  let marginTop = mobileHeaderTop

  headerAdNode = headerAdNode || node(SELECTORS.HEADER_AD_UNIT)
  if (!headerAdNode) {
    return
  }
  addTopComponentsMarginTop(marginTop)
  addPageWrapMarginTop(marginTop)
}

function addTopComponentsMarginTop(marginTop) {
  if (getIsMobile() || viewport.isPortrait) {
    headerAdNode.style.marginTop = 0
    getHeaderNode().style.marginTop = px(marginTop)
    if (getNavigationNode()) {
      getNavigationNode().style.marginTop = px(marginTop)
    }
  } else {
    headerAdNode.classList.add('isTablet')
  }
}

function addPageWrapMarginTop(marginTop) {
  const MOBILE_HEADER_HEIGHT = 88
  const pageWrapMarginTop = getIsTabletInPortrait() ? DESKTOP_HEADER_HEIGHT : MOBILE_HEADER_HEIGHT
  pageWrap = pageWrap || node(SELECTORS.PAGE_WRAP)
  pageWrap.style.marginTop = px(pageWrapMarginTop + marginTop)
}

let topSlotHeight

function onTopAdRendered(payload) {
  const { type, size, adId } = payload || {}
  if (type == TYPES.SLOT_RENDERED && adId == 'Top') {
    topSlotHeight = size.height
    attachHeaderRepositionHandlers()
    adStore.removeChangeListener(onTopAdRendered)
  }
}
function attachHeaderRepositionHandlers() {
  const mobileHeaderTop = adStore.state.topSlotHeight || topSlotHeight
  repositionMobileHeader({ mobileHeaderTop }) //should happen after init
  mobileHeaderOrientationHandler({ mobileHeaderTop })
}

export default function mountHeaderComponents() {
  initDialogProvider(!getIsMobileOrTablet())
  registerHamburger()
  initializeEditionSelection()
  injectSearch()
  mountAll({
    [MOUNT_POINTS.SEARCH_COMPONENT]: googleSearchComponent,
    [MOUNT_POINTS.USER_MENU_DROPDOWN]: userToolbarComponent,
  })
  adStore.addChangeListener(onTopAdRendered)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/headerComponents.js